import { render, staticRenderFns } from "./CustomerDropdown.vue?vue&type=template&id=58681380&scoped=true&"
import script from "./CustomerDropdown.vue?vue&type=script&lang=js&"
export * from "./CustomerDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDropdown.vue?vue&type=style&index=0&id=58681380&lang=scss&scoped=true&"
import style1 from "./CustomerDropdown.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58681380",
  null
  
)

export default component.exports